import Page from "components/Common/Page"
import {
  ConfirmTermText,
  CreateAccountBody,
  CreateAccountDescription,
  CreateAccountTitle,
} from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import TextField from "components/inputs/TextField"
import { useProfileForm } from "../hooks/profile"
import BirthDatePickerFormItem from "components/pickers/BirthDatePickerFormItem"
import GenderSelection from "./GenderSelection"
import Checkbox from "components/inputs/Checkbox"
import { useState } from "react"
import Button from "components/Buttons/Button"
import { useCreateFitProfile } from "features/auth/hooks"
import { IProfile } from "../profileTypes"
import { useSetPageTitle } from "libs/ga"

const initProfile = {
  name: "",
  profile: {
    birthedOn: "1990-12-01",
    gender: undefined,
  },
}

const CreateAccount = () => {
  useSetPageTitle("Create Account")
  const { name, setName, birthedOn, setBirthedOn, gender, setGender } =
    useProfileForm(initProfile)

  const [isAgreeToTerms, setIsAgreeToTerms] = useState(false)
  const [isSubscribeUpdate, setIsSubscribeUpdate] = useState(true)

  const isDisable = !name || !birthedOn || !gender || !isAgreeToTerms

  const { handleCreateFitProfile, createFitProfileLoading } =
    useCreateFitProfile()

  const handleSubmit = () => {
    if (isDisable) return
    const profile: IProfile = {
      name,
      profile: {
        birthedOn,
        gender,
      },
    }

    handleCreateFitProfile({ profile, isSubscribeUpdate })
  }

  return (
    <Page title="Create Account" theme="dark" noLeftAction isAppPaddingStyle>
      <CreateAccountBody>
        <FlexBox $direction="column" $gap={24}>
          <CreateAccountTitle>Details</CreateAccountTitle>
          <CreateAccountDescription>
            We need a few final details to create your account
          </CreateAccountDescription>

          <FlexBox $direction="column" $gap={8}>
            <TextField label="Name" value={name} onChange={setName} />

            <BirthDatePickerFormItem
              label="Date of birth"
              value={birthedOn}
              onChange={setBirthedOn}
            />

            <GenderSelection value={gender} onChange={setGender} />
          </FlexBox>

          <FlexBox $direction="column" $gap={8}>
            <FlexBox $gap={12}>
              <Checkbox
                checked={isSubscribeUpdate}
                onChange={setIsSubscribeUpdate}
              />{" "}
              <ConfirmTermText>
                I want to stay up-to-date on features, news and exclusive
                offers.
              </ConfirmTermText>
            </FlexBox>

            <FlexBox $gap={12}>
              <Checkbox checked={isAgreeToTerms} onChange={setIsAgreeToTerms} />{" "}
              <ConfirmTermText>
                I am over 16 years of age and agree to{" "}
                <ConfirmTermText>
                  ZOZOFIT’s{" "}
                  <a href="https://zozofit.com/pages/terms-conditions">
                    Terms of Service
                  </a>{" "}
                  and{" "}
                  <a href="https://zozofit.com/pages/privacy-policy">
                    Privacy Policy
                  </a>
                </ConfirmTermText>
              </ConfirmTermText>
            </FlexBox>
          </FlexBox>

          <Button
            $borderLess
            $type="primary"
            $theme="dark"
            disabled={isDisable}
            onClick={handleSubmit}
            loading={createFitProfileLoading}
          >
            Continue
          </Button>
        </FlexBox>
      </CreateAccountBody>
    </Page>
  )
}

export default CreateAccount
